import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'
import {
  ScheduleAmendment,
  useApplyAmendmentToQuote
} from './useApplyAmendmentToQuote'

export const useApplyScheduleAmendment = () => {
  const { displayNotification } = useNotifications()
  const applyAmendmentToQuote = useApplyAmendmentToQuote()

  return useCallback(
    async (amendment: ScheduleAmendment): Promise<boolean> => {
      const isApplied = await applyAmendmentToQuote(amendment)

      if (!isApplied) {
        displayNotification('Unable to apply schedule amendment to quote', {
          type: 'error'
        })
        return false
      }

      displayNotification('Schedule amendment applied to quote', {
        type: 'success'
      })
      return true
    },
    [applyAmendmentToQuote, displayNotification]
  )
}
